import type { IPaymentItem } from "@src/types/AppTypes";
import { createContext } from "react";

export const CardsContext = createContext<IPaymentItem[]>([]);

export const CardsDisptchContext = createContext<
  React.Dispatch<
    | { type: "setCards"; payload: IPaymentItem[] }
    | { type: "appendCard"; payload: IPaymentItem }
  >
>(() => {});

export function cardsReducer(
  state: IPaymentItem[],
  action:
    | { payload: IPaymentItem[]; type: "setCards" }
    | { payload: IPaymentItem; type: "appendCard" }
) {
  if (action.type === "setCards") {
    return action.payload;
  } else if (action.type === "appendCard") {
    return [...state, action.payload];
  } else {
    return state;
  }
}
